import React, { useEffect, useState } from 'react'
import { GetAll_Reserve_User_Api, RemoveUserFromReserve_Reserve_User_Api } from '../../API/ReserveUserApi';
import { Button, Col, Modal, Row, Image,rid, Card, Space, Typography,Grid } from 'antd';
import {  DeleteOutlined} from '@ant-design/icons';
import { ReserveStatus } from '../Reserve/ReserveStatus';

import '../../assets/css/PrintOthersComponent.css';

// ======================================================================
export const AllOthersComponent = ({ setLoading, showMessage, reserveId, reserve, printType, period, version, currentPage, setCurrentPage, isShowDelete, onRowDeleted }) => {
  // ======================================================================
  const [reserveUsers, setReserveUsers] = useState([]);
  const [pageCount, setPageCount] = useState(4);
  // ======================================================================
  useEffect(() => {
    loadData();
  }, [currentPage, version]);
  // ======================================================================
  const loadData = async () => {
    setLoading(true);
    try {
      const data = await GetAll_Reserve_User_Api({ ReserveId: reserveId, isPrimaryOnly: false });
      setLoading(false);
      if (data.messageStatus == "Successful") {
        setPageCount(data.messageData.pageCount * 10)
        setReserveUsers(data.messageData.data);
      }
      else
        showMessage(data.message, "error")
    }
    catch (error) {
      setLoading(false);
      showMessage("خطا در ارتباط با سرور.", "error")
    }
  }
  // ======================================================================
  const deleteRow = async (userId) => {
    try {
      setLoading(true);
      let data = await RemoveUserFromReserve_Reserve_User_Api({ reserveId: reserveId, userId: userId });
      setLoading(false);
      if (data.messageStatus == "Successful") {
        showMessage(data.message, "Successful");
        onRowDeleted();
      }
      else
        showMessage(data.message, "error")
    }
    catch (error) {
      setLoading(false);
      showMessage("خطا در ارتباط با سرور.", "error")
    }
  }
  const { useBreakpoint } = Grid;
const { Text } = Typography;

const screens = useBreakpoint();
  // ======================================================================
  return (
    <>

      <div className="no-print">

<div className="container">

    {!screens.sm ? (

        // ========================= موبایل =========================
        reserveUsers.map((reserveUser) => (
            <Card
                key={reserveUser.userId}
                size="small"
                style={{
                    marginBottom: 12,
                    borderRadius: 8
                }}
            >
                <Row gutter={[8, 8]} align="middle">

                    <Col span={5}>
                        <Image
                            width={55}
                            height={70}
                            src={reserveUser.photoUrl}
                        />
                    </Col>

                    <Col span={19}>

                        <div style={{ fontWeight: "bold", fontSize: 15 }}>
                            {reserveUser.userFullName}
                        </div>

                        <div style={{ marginTop: 6 }}>
                            <b>کد ملی:</b> {reserveUser.nationalCode || "-"}
                        </div>

                        <div>
                            <b>نام پدر:</b> {reserveUser.fatherName || "-"}
                        </div>

                        <div>
                            <b>سن:</b> {reserveUser.age} سال
                        </div>

                        <div>
                            <b>نسبت:</b> {reserveUser.isPrimary ? "نفر اصلی" : reserveUser.relationTitle}
                        </div>

                    </Col>

                    {isShowDelete && (
                        <Col span={24}>
                            <Button
                                danger
                                block
                                icon={<DeleteOutlined />}
                                onClick={() => {
                                    Modal.confirm({
                                        title: `آیا از حذف ${reserveUser.userFullName} اطمینان دارید؟`,
                                        onOk: () => deleteRow(reserveUser.userId),
                                        footer: (_, { OkBtn, CancelBtn }) => (
                                            <>
                                                <CancelBtn />
                                                <OkBtn />
                                            </>
                                        ),
                                    });
                                }}
                            >
                                حذف
                            </Button>
                        </Col>
                    )}

                </Row>
            </Card>
        ))

    ) : (

        // ========================= دسکتاپ =========================
        <>
            <Row className='titleRow'>
                <Col xs={0} sm={0} md={2} lg={2} xl={2} className='titleColumn'></Col>
                <Col xs={11} sm={5} md={5} lg={5} xl={5} className='titleColumn'>
                    نام و نام خانوادگی
                </Col>
                <Col xs={0} sm={4} md={4} lg={4} xl={4} className='titleColumn'>
                    نام پدر
                </Col>
                <Col xs={0} sm={4} md={4} lg={4} xl={4} className='titleColumn'>
                    کد ملی
                </Col>
                <Col xs={8} sm={4} md={3} lg={3} xl={3} className='titleColumn'>
                    نسبت
                </Col>
                <Col xs={4} sm={4} md={4} lg={4} xl={4} className='titleColumn'>
                    سن
                </Col>
            </Row>

            {reserveUsers.map((reserveUser, key) => (
                <Row key={key} className="valueRow">

                    <Col xs={0} sm={0} md={2} lg={2} xl={2}>
                        <Image
                            width={30}
                            height={40}
                            src={reserveUser.photoUrl}
                        />
                    </Col>

                    <Col xs={11} sm={5} md={5} lg={5} xl={5} className='valueColumn others-value-column'>
                        {reserveUser.userFullName}
                    </Col>

                    <Col xs={0} sm={4} md={4} lg={4} xl={4} className='valueColumn others-value-column'>
                        {reserveUser.fatherName}
                    </Col>

                    <Col xs={0} sm={4} md={4} lg={4} xl={4} className='valueColumn others-value-column'>
                        {reserveUser.nationalCode}
                    </Col>

                    <Col xs={8} sm={4} md={3} lg={3} xl={3} className='valueColumn others-value-column'>
                        {reserveUser.isPrimary ? "نفر اصلی" : reserveUser.relationTitle}
                    </Col>

                    <Col xs={0} sm={4} md={4} lg={4} xl={4} className='valueColumn others-value-column'>
                        {reserveUser.age} سال
                    </Col>

                    <Col xs={4} sm={2} md={2} lg={2} xl={2} className='valueColumn others-value-column'>
                        {isShowDelete && (
                            <Button
                                className='btn-danger'
                                style={{ width: '100%' }}
                                onClick={() => {
                                    Modal.confirm({
                                        title: 'آیا از حذف ' + reserveUser.userFullName + ' اطمینان دارید؟',
                                        onOk: () => deleteRow(reserveUser.userId),
                                        footer: (_, { OkBtn, CancelBtn }) => (
                                            <>
                                                <CancelBtn />
                                                <OkBtn />
                                            </>
                                        ),
                                    });
                                }}
                            >
                                <DeleteOutlined />
                                حذف
                            </Button>
                        )}
                    </Col>

                </Row>
            ))}
        </>

    )}

</div>

      </div>

      <div className="only-print">
        {printType == "factor" ?
          <div className="table-container">
            <h3 style={{ textAlign: 'center' }}>
              اطلاعات همراهان
            </h3>
            <table className="others-table">
              <thead  >
                <tr>
                  <th >ردیف</th>
                  <th  >نام</th>
                  <th >نام خانوادگی</th>
                  <th >کد ملی</th>
                  <th >نام پدر</th>
                  <th >تاریخ تولد</th>
                  <th >محل تولد</th>
                  <th >نسبت</th>
                </tr>
              </thead>
              <tbody>
                {/* {reserveUsers.filter(x => !x.isPrimary).map((user, index) => { */}
                {reserveUsers.map((user, index) => {

                  return (
                    <tr key={user.userId} className="text-center">
                      <td >{index + 1}</td>
                      <td >{user.name}</td>
                      <td >{user.family}</td>
                      <td >{user.nationalCode}</td>
                      <td >{user.fatherName}</td>
                      <td >{user.shamsiBirthDate}</td>
                      <td >-</td>
                      <td >{user.relationTitle || "-"}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div> :
          <>
 <br />
                    <div className="table-container">
                      <table className="others-table">
                        <thead>
                          <tr>
                            <th style={{textAlign:'center'}}>امضا متقاضی</th>
                            <th style={{textAlign:'center'}}>مهر و امضا مسئول امور مالی</th>
                            <th style={{textAlign:'center'}}>مهر و امضا مسئول پارکینگ</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr >
                            <td><br />
                            <br /></td>
                            <td><br /><br /></td>
                            <td><br /><br /></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
            {reserveUsers.filter(x => !x.isPrimary).map((user, index) => {

              return (
                <>
                  <br />
                  <div >
                    <table className="others-table">
                      <tr>
                        <td> <span className='bold'>شماره پذیرش : {reserve.trackingCode}</span></td>
                       
                        <td><span className='bold'>وضعیت پذیرش: </span> <span> <ReserveStatus reserveStatus={reserve.reserveStatus} /></span></td>
                        <td>  <span className='bold'>{reserve.objectInstance?.title || '-'} </span></td> 
 
                      
                      </tr>
                      <tr>
                      <td> <div className='bold' style={{ display: 'inline-block' }}>تاریخ تنظیم  :</div>  <span>{reserve.createDateShamsi}  </span></td>

                        <td> <span className='bold'>تاریخ ورود: </span>
                          <span> <span>{reserve.from_Shamsi_DayOfWeek} </span>
                            <div style={{ display: 'inline' }} >{reserve.from_Shamsi}</div></span></td>
                            <td><span className='bold'>تاریخ خروج: </span>
                          <span>{reserve.to_Shamsi_DayOfWeek} </span>
                          <div style={{ display: 'inline' }} >{reserve.to_Shamsi}</div>
                        </td>

                      </tr>
                      <tr>
                      <td> <span className='bold'>نام و نام خانوادگی : </span> <span>{user.name + ' ' + user.family}</span></td>
                      <td> <span className='bold'>تاریخ تولد : </span> <div style={{ display: 'inline' }} >{user.shamsiBirthDate }</div></td>
                        <td> <span className='bold'>کد ملی : </span> <span>{user?.nationalCode}</span></td>
                      </tr>
                      <tr>
                        <td> <span className='bold'>سرپرست : </span> <span>{reserve.fullName}</span></td>
                        <td> <span className='bold'>همراه سرپرست : </span> <span>{reserve.mobile}</span></td>
                        <td> <span className='bold'>نسبت : </span> <span>{ user.relationTitle} </span></td>
                        {/* */}
                      </tr>

                    </table>
                   
                  </div>
                </>
              );
            })}
          </>}
      </div>
    </>
  )
}